import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BulbIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.40333 17.5556H14.5956M12 2V3.11111M19.0711 4.92889L18.2856 5.71444M22 12H20.8889M3.11111 12H2M5.71444 5.71444L4.92889 4.92889M8.07111 15.9289C7.2943 15.1519 6.76533 14.162 6.55109 13.0843C6.33684 12.0067 6.44695 10.8897 6.86748 9.87468C7.28801 8.85962 8.00008 7.99205 8.91365 7.38166C9.82723 6.77127 10.9013 6.44548 12 6.44548C13.0987 6.44548 14.1728 6.77127 15.0863 7.38166C15.9999 7.99205 16.712 8.85962 17.1325 9.87468C17.5531 10.8897 17.6632 12.0067 17.4489 13.0843C17.2347 14.162 16.7057 15.1519 15.9289 15.9289L15.32 16.5367C14.9719 16.8848 14.6958 17.2982 14.5074 17.753C14.3191 18.2079 14.2222 18.6954 14.2222 19.1878V19.7778C14.2222 20.3671 13.9881 20.9324 13.5713 21.3491C13.1546 21.7659 12.5894 22 12 22C11.4106 22 10.8454 21.7659 10.4287 21.3491C10.0119 20.9324 9.77778 20.3671 9.77778 19.7778V19.1878C9.77778 18.1933 9.38222 17.2389 8.68 16.5367L8.07111 15.9289Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

BulbIcon.displayName = 'BulbIcon';
